import { AppEventDispatcher } from './../../utils/AppEventDispatcher';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { EventTypes } from '../EventTypes';
import { TweenMax, Quint } from 'gsap';
import { SharedService } from '../shared.service';
import { ThemeService } from '../theme-service/theme.service';

@Component({
	selector: 'app-terms',
	templateUrl: './terms.component.html',
	styleUrls: ['./terms.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class TermsComponent implements OnInit, OnDestroy {

	text: string;
	acceptHandler: any;
	acceptHandlerData: any;
	loading = false;
	access: any;

	constructor(
		private sharedService: SharedService,
		private themeService: ThemeService
	) { }
	
	ngOnInit() {
		this.text = this.themeService.themeConfigs ? this.themeService.themeConfigs.TermosUso : null;
		AppEventDispatcher.listen( EventTypes.TERMS.TERMS, data => {
			if (this.text === null) {
				this.text = data.text;
			} 
			this.acceptHandler = data.acceptHandler;
			this.acceptHandlerData = data.acceptHandlerData;
			this.access = data.access;
			if (data.show) {
				this.show();
			} else {
				this.hide();
			}
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener( EventTypes.TERMS.TERMS );
	}

	show() {
		$('[data-component="terms"]').show();
		TweenMax.to('[data-component="terms"] .modal', 1, {top: '50%', ease: Quint.easeOut});
	}

	hide() {
		TweenMax.to('[data-component="terms"] .modal', .6, {top: '-150%', ease: Quint.easeIn, onComplete: () => {
			$('[data-component="terms"]').hide();
		}});
	}

	accept() {

		if (!this.loading) {

			this.loading = true;

			this.sharedService.acceptTerms().subscribe( data => {
				this.loading = false;
				this.hide();
				this.acceptHandler.checkAfterTerms(this.access);
			}, error => {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem});
			});

		}

	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/terms/terms.component.ts